import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { orgLessStaffGuard } from 'app/core/guards/org-less-staff.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { adminFeatureRoutes } from './admin-feature.routes';
import { RouteDataAuthorizationGuard } from './route-data-authorization.guard';

/** Authenticated app shell: AuthGuard + route data.anyRoles / permissions. */
export const adminShellRoutes: Route = {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [
        AuthGuard,
        orgLessStaffGuard,
        RouteDataAuthorizationGuard,
    ],
    component: LayoutComponent,
    resolve: {
        initialData: initialDataResolver,
    },
    children: adminFeatureRoutes,
};
